import React, { useEffect, useState } from "react";
import { Button, InputSelect, InputText } from "@tvg/design-system/web";
import { TARGETS } from "../../constraints";
import { buildUrl, hasDevstack, toBranch, toTarget } from "../../devstack";
import type { EnvironmentModalProps, Target } from "../../types";
import { Wrapper } from "./styled-component";

export const DevstackContent = ({
  env,
  brand,
  currentDevstackName,
  isOpen
}: EnvironmentModalProps) => {
  const [selectedEnv, setSelectedEnv] = useState<Target>(() => toTarget(env));
  const [devstackName, setDevstackName] = useState(currentDevstackName);

  useEffect(() => {
    if (isOpen) {
      setDevstackName(currentDevstackName);
    }
  }, [currentDevstackName, isOpen]);

  return (
    <Wrapper>
      <InputSelect
        qaLabel="environment"
        label="Environment"
        selectList={TARGETS}
        selectedValue={selectedEnv}
        // onChangeText, not onChange: the design system hands both the picked
        // value rather than an event, and only this one is typed for it.
        onChangeText={(value) => setSelectedEnv(value as Target)}
      />
      {hasDevstack(selectedEnv) && (
        <InputText
          qaLabel="devstack-name"
          label="Devstack name"
          placeholder="Leave blank if you don't want a devstack."
          messageBellow="Valid values: my-branch | fb-my-branch | -fb-my-branch"
          isOptional
          value={devstackName}
          onChange={(event) => setDevstackName(event.target.value)}
        />
      )}
      <Button
        qaLabel="devstack-button"
        variant="primary"
        isStretched
        onClick={() => {
          window.location.href = buildUrl(
            selectedEnv,
            brand,
            toBranch(devstackName)
          );
        }}
      >
        Set and reload
      </Button>
    </Wrapper>
  );
};

export default DevstackContent;
